import PropTypes from 'prop-types'

function TextAreaField({
  name,
  onChange,
  label,
  value,
  placeholder,
  additionalClass,
  isError,
  ...props
}) {
  return (
    <div className="field">
      {label && (
        <label htmlFor={name} className={`label ${isError && 'is-danger'}`}>
          {label}
        </label>
      )}
      <div className="control">
        <textarea
          className={`textarea ${additionalClass || ''} ${isError && 'is-danger'}`}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          {...props}
        />
      </div>
    </div>
  )
}

TextAreaField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  additionalClass: PropTypes.string,
  disabled: PropTypes.bool,
  rows: PropTypes.number,
  isError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

export default TextAreaField
